import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../helper/CropImage';
import { Modal, Button } from 'react-bootstrap';

const ImageCropper = ({ image, onCropComplete, onCancel }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropSize, setCropSize] = useState(250);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropChange = useCallback((crop) => {
    setCrop(crop);
  }, []);

  const onCropCompleteCallback = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onZoomChange = useCallback((zoom) => {
    setZoom(zoom);
  }, []);

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(image, croppedAreaPixels);
      onCropComplete(croppedImage);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal show={true} onHide={onCancel} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Crop Image</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '400px', position: 'relative' }}>
        <Cropper
          image={image}
          crop={crop}
          zoom={zoom}
          cropSize={{ width: cropSize, height: cropSize }}
          onCropChange={onCropChange}
          onCropComplete={onCropCompleteCallback}
          onZoomChange={onZoomChange}
          showGrid={true}
        />
      </Modal.Body>
      <Modal.Footer className="d-flex flex-column align-items-stretch">
        <div className="px-4 py-2 row">
            <div className="col-md-6">
                <label className="form-label">Zoom</label>
                <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e) => onZoomChange(e.target.value)}
                    className="form-range"
                />
            </div>
            <div className="col-md-6">
                <label className="form-label">Crop Area Size</label>
                <input
                    type="range"
                    value={cropSize}
                    min={50}
                    max={400}
                    step={1}
                    aria-labelledby="Crop Area Size"
                    onChange={(e) => setCropSize(Number(e.target.value))}
                    className="form-range"
                />
            </div>
        </div>
        <div className="d-flex justify-content-end gap-2 p-2">
          <Button variant="outline-danger" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={showCroppedImage}>
            Crop & Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageCropper;
